import { ProductCartItemAnalyticsService, ProductListAnalyticsService } from '@analytics/feature';
import { ChangeDetectionStrategy, Component, Input, Optional } from '@angular/core';
import { CustomOrderEntry } from '@cart/const';
import { CustomActiveCartService } from '@cart/data-access';
import { CustomProduct } from '@product/const';
import { SdvorButtonComponent } from '@sdvor/shared/ui/v2';
import { filter, take } from 'rxjs';

@Component({
  selector: 'sd-item-add-to-cart',
  templateUrl: './item-add-to-cart.component.html',
  imports: [SdvorButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemAddToCartComponent {
  @Input() product: CustomProduct;
  @Input() productIndex?: number;
  @Input() transit = false;

  constructor(
    private customActiveCartService: CustomActiveCartService,
    private productCartItemAnalyticsService: ProductCartItemAnalyticsService,
    @Optional() private productListAnalyticsService: ProductListAnalyticsService,
  ) {}

  addToCartIfNeed(): void {
    if (!this.transit) {
      this.customActiveCartService
        .getEntry(this.product.code)
        .pipe(
          take(1),
          filter((entry?: CustomOrderEntry) => !entry),
        )
        .subscribe(() => {
          this.productCartItemAnalyticsService.saveForProduct(this.product, {
            listName: this.productListAnalyticsService?.getListName(),
            productIndex: this.resolveProductIndex(),
          });
          this.customActiveCartService.addEntry(this.product.code, this.product.price.orderMinimum);
        });
    }
  }

  private resolveProductIndex(): number | undefined {
    if (this.productIndex !== undefined && this.productIndex !== null) {
      return this.productIndex;
    }

    return this.productListAnalyticsService?.getProductIndex(this.product.code);
  }
}
